import React from 'react'

export default function EditMedium(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.8982 7.1208H5.89819C5.06977 7.1208 4.39819 7.79238 4.39819 8.6208V18.6208C4.39819 19.4492 5.06977 20.1208 5.89819 20.1208H15.8982C16.7266 20.1208 17.3982 19.4492 17.3982 18.6208V13.6208H18.8982V18.6208C18.8982 20.2777 17.555 21.6208 15.8982 21.6208H5.89819C4.24134 21.6208 2.89819 20.2777 2.89819 18.6208V8.6208C2.89819 6.96395 4.24134 5.6208 5.89819 5.6208H10.8982V7.1208Z'
        fill='currentColor'
      />
      <path d='M13.2829 10.1981L19.1601 4.3209' stroke='currentColor' strokeWidth={2.5} />
      <path
        d='M13.8249 11.4367L12.0664 9.67819L11.3665 12.1186L13.8249 11.4367Z'
        fill='currentColor'
      />
      <rect
        x={19.3397}
        y={2.3792}
        width={2.49192}
        height={1}
        transform='rotate(45 19.3397 2.3792)'
        fill='currentColor'
      />
    </svg>
  )
}
